module.exports = __webpack_public_path__ + "static/media/optima-seguros-headset.6b75081c.svg";